<template>
	<div
		class="fixed-container-br"
		v-bind:class="{ hidden: !buttonVisble, visible: buttonVisble }"
	>
		<!-- <button
			class="button hover-button"
			v-on:click="onBugReport()"
			id="bug-report-button"
		>
			Report a Bug
		</button>
		<button
			v-on:click="buttonVisble = !buttonVisble"
			id="toggle-visibility-button"
		>
			<i class="fas fa-times"></i>
		</button> -->
	</div>
</template>

<style lang="scss">
@import "~@styles/scss/base/all";
@import "~@styles/scss/vendor/settings";

.fixed-container-br {
	display: block;
	position: fixed;
	right: 1rem;
	bottom: 1rem;
	z-index: 100;

	&.visible {
		animation: show 0.4s forwards;
	}

	&.hidden {
		animation: hide 0.4s forwards;
	}

	@keyframes hide {
		0% {
			display: block;
			transform: translate(0, 0);
		}
		100% {
			display: none;
			transform: translate(0, 150%);
		}
	}

	@keyframes show {
		0% {
			display: block;
			transform: translate(0, 150%);
		}
		100% {
			transform: translate(0, 0);
		}
	}

	.hover-button {
		margin-bottom: 0;
		background-color: hsl(38, 100, 55);
		box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
		padding-right: 2.75rem;
		color: #000;
		font-weight: 700;

		&:hover {
			cursor: pointer;
			background-color: hsl(38, 100, 50);
		}

		@include breakpoint(medium) {
			font-size: 0.9em;
		}
	}

	#toggle-visibility-button {
		display: block;
		position: fixed;
		top: 0.95rem;
		right: 0.5rem;
		color: #000;
		font-weight: 700;
		font-size: 2em;

		&:hover {
			cursor: pointer;
			color: #333;
		}

		@include breakpoint(medium) {
			font-size: 0.8rem;
			top: 0.4rem;
		}
	}

	@include breakpoint(medium) {
		right: 0.5rem;
		bottom: 0.5rem;
	}
}
</style>

<script>
import axios from "axios";

export default {
	data: () => {
		return {
			buttonVisble: false,
		};
	},
	mounted: function () {},
	methods: {
		onBugReport: async function () {
			let localStorageObject = {};
			let sessionStorageObject = {};

			let i;

			for (i = 0; i < localStorage.length; i++) {
				localStorageObject[localStorage.key(i)] = localStorage.getItem(
					localStorage.key(i)
				);
			}

			for (i = 0; i < sessionStorage.length; i++) {
				sessionStorageObject[
					sessionStorage.key(i)
				] = sessionStorage.getItem(sessionStorage.key(i));
			}

			const { data, status } = await axios.post(
				"/wp-json/ferg/V1/bug-report",
				{
					localStorage: localStorageObject,
					sessionStorage: sessionStorageObject,
					url: window.location.href,
				}
			);

			if (data || status != 200) {
				window.open(data, "_blank");
			} else {
				alert("Something went wrong...");
			}
		},
	},
};
</script>